import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AuthService } from './auth.service';
import { ChatService } from "./chat.service";
import { map, switchMap } from 'rxjs/operators';
import { Observable, combineLatest, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {
  static RESERVED = 'reserved';
  static CANCELLED = 'cancelled';
  static FINISHED = 'finished';

  static TEMPLATE_RESERVED = "{{time}}のアバター通話が予約されました。";

  constructor(
    private afs: AngularFirestore,
    private auth: AuthService,
    private cs: ChatService
  ) {}

  createReservation(params) {
    return this.afs.collection('reservations').add(params)
  }

  public updateReservationData(data, merge = true) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`reservations/${data.uid}`);

    return userRef.set(data, { merge });
  }

  getReservationsQuery() {
    const compareField = this.auth.user.role === AuthService.USER_ROLE ? 'user_uid' : 'vtuber_uid';
    return this.afs
      .collection('reservations', ref => ref.where(compareField, '==', this.auth.user.uid).orderBy('reserveAt', 'desc').orderBy('start', 'desc'))
      .snapshotChanges()
      .pipe(
        map(actions => {
          return actions.filter((item: any) => item.payload.doc.data().status !== ReservationService.CANCELLED).map(a => {
            const data: Object = a.payload.doc.data();
            const id = a.payload.doc.id;

            return { id, ...data };
          });
        })
      );
  }

  async sendNotification(userID: string, vtuberID: string, template: any) {
    this.afs
      .collection('chats', ref => ref.where('user.uid', '==', userID).where('vtuber.uid', '==', vtuberID))
      .get()
      .toPromise()
      .then(response => {
        if (response.docs.length > 0) {
          let data = response.docs[0].data()
          data.messages.push({
            createdAt: Date.now(),
            message: template,
            sender: vtuberID,
            type: 'message'
          })
          data.lastMessage = template
          data.lastMessageAt = Date.now()
          data.vtuber.count++;

          this.cs.updateChatData(data)
        }
      })
  }

  getReservations(reservation$: Observable<any>) {
    let reservations = [];
    const joinKeys = {};
    let isUser = this.auth.user.role === AuthService.USER_ROLE;

    return reservation$.pipe(
      switchMap(c => {
        // Unique User IDs
        reservations = c;
        let uids = [];
        reservations.map(reservation => {
          if (isUser) {
            if (!uids.includes(reservation.vtuber_uid)) {
              uids.push(reservation.vtuber_uid)
            }
          } else {
            if (!uids.includes(reservation.user_uid)) {
              uids.push(reservation.user_uid)
            }
          }
        })

        // Firestore User Doc Reads
        const userDocs = uids.map(u =>
          this.afs.doc(`users/${u}`).valueChanges()
        );

        return userDocs.length ? combineLatest(userDocs) : of([]);
      }),
      map(arr => {
        arr.forEach(v => (joinKeys[(<any>v).uid] = v));
        return reservations.map(reservation => {
          let uid = isUser ? reservation.vtuber_uid : reservation.user_uid;

          reservation.target = joinKeys[uid]

          return reservation;
        })
      })
    );
  }
}
